module.exports = __webpack_public_path__ + "img/gp-btn.3daf35a6.png";